'use strict';



const $ = require('jquery');
const rangeslider = require('rangeslider.js');
const debounce = require('debounce');
const confirmFormSubmit = require('./confirm-form-submit');
const parseCurrency = require('./parse-currency');
const $amountInput = $('.js-sell-loan-part-amount');
const $form = $('.js-sell-loan-part');
let submitting = false;



$amountInput
	.filter(`[type='range']`)
	.rangeslider({ polyfill: false });



const onInput = debounce(function() {

	const $input = $(this);
	const val = parseCurrency($input.val());

	const [ min, max ] = [ 'min', 'max' ]
		.map(attr => $input.attr(attr) || $input.data(attr))
		.map(number => parseFloat(number));

	render($(this), min, max);

}, 10);



$amountInput
	.filter(`[type='range']`)
	.on('input', onInput);



$form.on('submit', e => {
	if(submitting && !e.notDuplicate) {
		e.preventDefault();
		return;
	}
});



confirmFormSubmit(
	$form,
	() => {

		const $input = $amountInput
			.filter(`[type='text']`);

		const value = $input[0].inputmask ?
			parseFloat($input[0].inputmask.unmaskedvalue()) :
			0;

		const min = parseFloat($input.data('min'));
		const max = parseFloat($input.data('max'));

		if(value > max) {
			$input.val(max);
		}

		if(value < min) {
			$input.val(min);
		}

		const amount = $input.val();

		return `
			<p>Are you sure you wish to sell ${amount} of this loan part?</p>
			<p>You will cease to earn interest on the amount you choose to sell at the point you click to confirm. Once the total amount has sold we will credit the balance to your account. Any unpaid interest accrued prior to sale will be credited at the end of the month as usual.</p>
			<p>If you cancel this loan part sale you will commence earning interest from the date it is cancelled. You will not earn interest for the period when it was for sale.</p>`;

	},
	() => submitting = true
);



function render($changed, min, max) {

	const i = $changed.parents('.js-sell-loan-part-amount-container').index();
	let val = parseCurrency($changed.val());

	$amountInput
		.filter(function() {
			return $(this).parents('.js-sell-loan-part-amount-container').index() !== i;
		})
		.val(val)
		.filter(`[type='range']`)
		.change();

}
